export default "__VITE_ASSET__BA5AOWNs__"